import { render, staticRenderFns } from "./ReportDocumentAction.vue?vue&type=template&id=844681a6"
import script from "./ReportDocumentAction.vue?vue&type=script&lang=ts"
export * from "./ReportDocumentAction.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports